export const LINEAR = 'linear';
export const NONLINEAR = 'non-linear';
